module.exports = __webpack_public_path__ + "static/assets/29b9c4d9e1b7974e62f1d599494c301f.svg";